// Context to store data related with the current vet clinic, populated by the VetClinicManager on navigation changes and consumable through the useVetClinic hook
import { createContext, type ReactNode, type FC, useState } from 'react'
import type { TypeCmsVetDetail } from '@/schema'

export type TypeVetClinicData = Partial<Pick<TypeCmsVetDetail, 'id' | 'clivirbac' | 'status' | 'fiscal_cif' | 'fiscal_name' | 'old_clinic' | 'new_clinic'>>

type VetClinicContextProps = {
  vetClinicData: TypeVetClinicData | null
  setVetClinicData: (data: TypeVetClinicData | null) => void
  setVetClinicIsDisabled: (isDisabled: boolean) => void
	vetClinicIsDisabled: boolean
}

export const VetClinicContext = createContext<VetClinicContextProps | undefined>(undefined)

export const VetClinicProvider:FC<{ children: ReactNode }> = ({ children }) => {
  const [vetClinicData, setVetClinicData] = useState<TypeVetClinicData | null>(null)
	const [vetClinicIsDisabled, setVetClinicIsDisabled] = useState(false)

  return <VetClinicContext.Provider value={{ vetClinicData, setVetClinicData, setVetClinicIsDisabled, vetClinicIsDisabled }}>{children}</VetClinicContext.Provider>
}
